(function () {
  const STATUS_DURATION = 2000;
  const STATUS_TRANSITION_DURATION = 250;

  function resetStatus(copyLink) {
    copyLink.classList.remove('copied', 'not-copied');

    const statusEl = copyLink.querySelector('.copy-btn__status');
    if (statusEl) statusEl.remove();
  }

  function showStatus(copyLink, state, message) {
    clearTimeout(copyLink._copyStatusHideTimeout);
    clearTimeout(copyLink._copyStatusRemoveTimeout);

    let statusEl = copyLink.querySelector('.copy-btn__status');

    if (!statusEl) {
      statusEl = document.createElement('span');
      statusEl.className = 'copy-btn__status';
      statusEl.setAttribute('aria-live', 'polite');
      copyLink.appendChild(statusEl);
    }

    statusEl.textContent = message;
    copyLink.classList.remove('copied', 'not-copied');
    void statusEl.offsetWidth;
    copyLink.classList.add(state);

    copyLink._copyStatusHideTimeout = setTimeout(() => {
      copyLink.classList.remove(state);
      copyLink._copyStatusRemoveTimeout = setTimeout(() => {
        resetStatus(copyLink);
      }, STATUS_TRANSITION_DURATION);
    }, STATUS_DURATION);
  }

  function copyURI(evt, copyLink) {
    evt.preventDefault();

    const url = window.location.href;
    const successMessage = copyLink.dataset.copySuccessMessage || 'Copied!';
    const errorMessage = copyLink.dataset.copyErrorMessage || 'Unable to copy link';

    const handleCopy = (success) => {
      showStatus(copyLink, success ? 'copied' : 'not-copied', success ? successMessage : errorMessage);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => handleCopy(true))
        .catch(() => handleCopy(false));
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = url;
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        handleCopy(successful);
      } catch (err) {
        handleCopy(false);
      }

      document.body.removeChild(textArea);
    }
  }

  const copyLinks = document.querySelectorAll('.copy-btn');

  for (const copyLink of copyLinks) {
    copyLink.addEventListener('click', (evt) => copyURI(evt, copyLink));
  }
})();
